<template>
  <div class="header">
    <div class="header-left">
      <slot name="left">
        <div class="brand-item">
          <div class="logo-wrapper">
            <img src="/logo.png" alt="Logo" class="header-logo" />
          </div>
          <span class="brand-name">湖北省建筑劳务协会</span>
        </div>
      </slot>
    </div>
    
    <div class="header-right">
      <!-- 消息通知 -->
      <div class="action-item">
        <el-badge is-dot :offset="[2, 2]" class="notice-badge">
          <span class="material-symbols-outlined notice-icon">notifications</span>
        </el-badge>
      </div>

      <!-- 用户中心 -->
      <el-dropdown trigger="click" popper-class="header-dropdown">
        <div class="user-profile">
          <div class="user-info">
            <span class="user-name">{{ realName || 'ZC' }}</span>
            <span class="role-badge">{{ roleName || '超级管理员' }}</span>
          </div>
          <div class="avatar-wrapper">
            <img src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png" alt="Avatar" class="user-avatar" />
          </div>
          <span class="material-symbols-outlined expand-icon">expand_more</span>
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item @click="goToProfile">
              <span class="material-symbols-outlined text-sm mr-2">person</span>个人中心
            </el-dropdown-item>
            <el-dropdown-item divided @click="handleLogout" class="logout-item">
              <span class="material-symbols-outlined text-sm mr-2">logout</span>退出登录
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      realName: state => state.userInfo?.realName,
      organization: state => state.userInfo?.organization,
      roleName: state => state.userInfo?.roleName || state.userInfo?.role
    }),
  },
  methods: {
    goToProfile() { this.$router.push('/profile'); },
    handleLogout() {
      localStorage.clear();
      sessionStorage.clear();
      this.$router.push('/login');
    },
  },
};
</script>

<style scoped>
.header {
  height: 64px; /* 增加一点高度更有呼吸感 */
  background: linear-gradient(135deg, #4f46e5 0%, #3b82f6 100%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  color: white;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  z-index: 1000;
}

.header-left .brand-item {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.5px;
}

.header-logo {
  max-width: 85%;
  max-height: 85%;
  object-fit: contain;
}

.logo-wrapper {
  width: 42px;
  height: 42px;
  background: #fff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: 1.5px solid rgba(255, 255, 255, 0.2);
  flex-shrink: 0;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.action-item {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  transition: all 0.2s;
}

.action-item:hover {
  background: rgba(255, 255, 255, 0.15);
}

.notice-icon {
  font-size: 24px;
  color: rgba(255, 255, 255, 0.9);
}

.user-profile {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.user-profile:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
}

.user-info {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  line-height: 1.2;
}

.user-name {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 2px;
}

.role-badge {
  font-size: 10px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.85);
  background: rgba(255, 255, 255, 0.12);
  padding: 1px 6px;
  border-radius: 4px;
  letter-spacing: 0.5px;
}

.avatar-wrapper {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  padding: 2px;
  background: linear-gradient(to bottom right, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.1));
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.user-avatar {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.user-profile:hover .avatar-wrapper {
  transform: rotate(5deg) scale(1.05);
}

.expand-icon {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.6);
}

.logout-item {
  color: #f43f5e !important;
}

/* 消息通知红点样式修正 */
:deep(.el-badge__content.is-dot) {
  background-color: #f43f5e;
  border: 1.5px solid #3b82f6; /* 与背景色融合 */
  width: 10px;
  height: 10px;
}
</style>
